var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('button',{attrs:{"id":"back-to-top-btn"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa-solid fa-chevron-up"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }